export enum AppStoreActionTypes {
  SetLoading = 'SET_LOADING',
  SetIsHomePage = 'SET_IS_HOME_PAGE',
  SetRecentProject = 'SET_RECENT_PROJECT',
  RemoveLoading = 'REMOVE_LOADING',
  SetIssueTypeAvailability = 'SET_ISSUE_TYPE_AVAILABILITY',
  SetPublishSuccess = 'SET_PUBLISH_SUCCESS',
  SetPublishError = 'SET_PUBLISH_ERROR'
}

export type Project = {
  id: string;
  key: string;
  name: string;
};

export type AppState = {
  isLoading: boolean;
  loadingMessage: string;
  isHomePage: boolean;
  recentProject: Project | null;
  issueTypeAvailability: import('../../services/IssueTypeService').IssueTypeAvailability;
  isPublishSuccess: boolean;
  isPublishError: boolean;
  publishErrorMessage: string;
};

export type AppStorePayload = {
  [AppStoreActionTypes.SetLoading]: string;
  [AppStoreActionTypes.SetRecentProject]: Project;
  [AppStoreActionTypes.SetIsHomePage]: boolean;
  [AppStoreActionTypes.RemoveLoading]: undefined;
  [AppStoreActionTypes.SetIssueTypeAvailability]: import('../../services/IssueTypeService').IssueTypeAvailability;
  [AppStoreActionTypes.SetPublishSuccess]: boolean;
  [AppStoreActionTypes.SetPublishError]: string | false; // Error message or false to clear
};
